import { Component } from "react"
import UnsplashReact, { BlobUploader, withDefaultProps } from "unsplash-react"
import PropTypes from "prop-types"
import { HelperShelfMessage, HelperShelfTrigger } from "components/helper_shelf"
import { Pane } from "components/ui"
import { Box, Spinner, StackView } from "@planningcenter/tapestry-react"

class EventLogo extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isEditing: false,
      shwUnsplash: false,
      authenticityToken: null
    }
    this.handleToggleEditing = this.handleToggleEditing.bind(this)
    this.handleUploadClick = this.handleUploadClick.bind(this)
    this.handleToggleUnsplash = this.handleToggleUnsplash.bind(this)
    this.handleFileInputChange = this.handleFileInputChange.bind(this)
    this.handleBlobLoaded = this.handleBlobLoaded.bind(this)
  }

  componentDidMount() {
    this.setState({
      authenticityToken: document.querySelector('meta[name="csrf-token"]').content
    })
  }

  componentDidUpdate(_prevProps, prevState) {
    if (!prevState.isEditing && this.state.isEditing) {
      App.SweetWithConfirmed.init()
    }
  }

  handleToggleEditing() {
    this.setState(({ isEditing, showUnsplash }) => {
      const nextIsEditing = !isEditing
      const nextShowUnsplash = nextIsEditing && showUnsplash
      return { isEditing: nextIsEditing, showUnsplash: nextShowUnsplash }
    })
  }

  handleUploadClick() {
    this.fileInput.click()
  }

  handleToggleUnsplash() {
    this.setState(({ showUnsplash }) => ({ showUnsplash: !showUnsplash }))
  }

  handleFileInputChange(e) {
    e.preventDefault()
    this.handleBlobLoaded(this.fileInput.files[0])
  }

  handleBlobLoaded(blob) {
    this.setState({ showSpinner: true })
    const extension = blob.name ? `.${blob.name.split(".").pop()}` : ""

    const formData = new FormData()
    formData.append("event[logo]", blob, `image-${new Date().getTime()}${extension}`)

    return $.ajax({
      type: "PUT",
      headers: { "X-SRF-Token": $.rails.csrfToken() },
      data: formData,
      processData: false,
      contentType: false,
      url: this.props.url,
      success: _resp => {
        this.setState({ showSpinner: false })
      },
      error: _error => {
        this.setState({ showSpinner: false })
        alertModal({
          title: "An error occured",
          type: "error",
          text: "Your image is too large or is not in an accepted format (JPG, PNG, or GIF).",
          confirmButtonText: "Ok",
          closeOnConfirm: true
        })
      }
    })
  }

  render() {
    const { eventName, logo, url, accessKey } = this.props
    const { isEditing, showUnsplash, authenticityToken, showSpinner } = this.state
    return (
      <Pane>
        <Pane.Header flexWrap="wrap">
          <StackView axis="horizontal" gap="4px">
            <Pane.Title>Image</Pane.Title>
            <span className="p-r t-3p">
              <HelperShelfTrigger id="event_image_reqs" />
            </span>
          </StackView>
          <button className="xs-btn quiet-btn btn2" onClick={this.handleToggleEditing}>
            {isEditing ? "Cancel" : "Edit"}
          </button>
          <Box basis="100%">
            <HelperShelfMessage id="event_image_reqs">
              16:9 image ratio.
              <br />
              GIF, JPG, or PNG format.
              <br />
              <a
                target="_blank"
                href="https://support.planningcenteronline.com/hc/en-us/articles/18032518633115"
                rel="noreferrer"
              >
                View image specs
              </a>
            </HelperShelfMessage>
          </Box>
        </Pane.Header>
        <Pane.Body>
          {isEditing ? (
            <div>
              {showUnsplash ? (
                <div style={{ height: 325 }}>
                  <UnsplashReact
                    accessKey={accessKey}
                    applicationName="planning_center"
                    preferredSize={{ width: 1024, height: 768 }}
                    defaultSearch={eventName}
                    Uploader={withDefaultProps(BlobUploader, {
                      onBlobLoaded: this.handleBlobLoaded
                    })}
                    highlightColor="#46948d"
                    photoRatio={1024 / 768}
                    columns={2}
                  />
                </div>
              ) : (
                <div>
                  {showSpinner && (
                    <div
                      style={{
                        height: "100%",
                        position: "absolute",
                        width: "50%"
                      }}
                    >
                      <Spinner size="lg" />
                    </div>
                  )}
                  <img src={logo} className="event-image" alt="Signup logo" />
                </div>
              )}

              {showUnsplash ? (
                <div className="m-1">
                  <button className="sm-btn btn2" onClick={this.handleToggleUnsplash}>
                    Cancel
                  </button>
                </div>
              ) : (
                <div className="d-f@sm mt-2">
                  <div className="d-f@sm mb-1 mb-0@sm mr-1@sm">
                    <button
                      className="w-100% w-a@sm sm-btn btn2 mr-1@sm"
                      onClick={this.handleUploadClick}
                    >
                      Upload image
                    </button>
                    <button
                      className="w-100% w-a@sm mt-1 mt-0@sm sm-btn btn2"
                      onClick={this.handleToggleUnsplash}
                    >
                      Free photos
                    </button>
                  </div>
                  <SweetDelete url={url} label="logo" />
                </div>
              )}

              <form action={url} method="POST" encType="multipart/form-data" data-remote>
                <input name="_method" type="hidden" value="patch" />
                <input name="authenticity_token" type="hidden" value={authenticityToken} />
                <input
                  type="file"
                  accept="image/*"
                  name="event[logo]"
                  ref={e => (this.fileInput = e)}
                  onChange={this.handleFileInputChange}
                  className="d-n"
                />
              </form>
            </div>
          ) : (
            <button onClick={this.handleToggleEditing}>
              <img src={logo} className="event-image" alt="Signup logo" />
            </button>
          )}
        </Pane.Body>
      </Pane>
    )
  }
}

EventLogo.propTypes = {
  eventName: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  accessKey: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
}

function SweetDelete({ url, label }) {
  return (
    <button
      className="sweet-with-confirmed-js sm-btn quiet-destroy-btn btn2 w-100% w-a@sm ml-a@sm"
      data-confirmed-url={url}
      data-confirmed-title="Deleted!"
      data-confirmed-method="DELETE"
      data-confirmed-text={`The ${label} has been deleted`}
      data-confirmed-type="success"
      data-title={`Delete ${label}?`}
      data-text="This can't be undone."
      data-type="warning"
      data-button="Yes, delete it!"
    >
      Remove image
    </button>
  )
}

export default EventLogo
